import SingleSelectComponent from "../../../../components/single-select/single-select.component";
import { codeMasterType } from "../../../../config/constants";
import codeMasterModel from "../../../../models/common/code-master.model";
import loginModel from "../../../../models/login.model";
import ViewBase from "../../../view-base.view";
import CountryMapFormCardView from "./country-map-form-card.view";

/**
 * User Create Country Map Form view
 * 
 * This component is used to display a list of the user's managed country cards.
 * You can also add new managed countries to the user.
 * 
 * @author Darrus Goh 
 */
export default function UserCreateCountryMapFormView() {
  ViewBase.call(this);

  let scrollToId = '';
  let selectedCountry = null;
  let countriesMap = {};

  let getCountries = () => {
    codeMasterModel.getByCategoryV2({ category: codeMasterType.country, countryCode: loginModel.credentials.country })
      .then((result) => {
        if (result) {
          result.forEach((country) => {
            countriesMap[country.code] = { code: country.code, name: country.name };
          });
        }
      })
      .catch((error) => {
        return [];
      })
  }

  const addCountry = (user, onChange) => () => {
    const newUser = structuredClone(user);
    newUser.countryMap[selectedCountry.code] = {};
    scrollToId = `#countryMapCard-${selectedCountry.code}`;
    onChange(newUser);
    selectedCountry = null;
  }

  return {
    oninit: () => {
      getCountries();
    },
    onupdate: () => {
      if (scrollToId !== '') {
        document.querySelector(scrollToId).scrollIntoView({ behavior: 'smooth', block: 'center' });
        scrollToId = '';
      }
    },
    view: ({ attrs: { user, onChange } }) => {
      const userManagedCountries = user ? Object.keys(user.countryMap).filter(country => country !== user.defaultCountryCode) : [];

      return m('div',
        m("a.btn.btn-primary.btn-search", {
          'data-bs-toggle': "collapse",
          'aria-controls': "countryMap-section",
          'aria-expanded': "true",
          href: "#countryMap-section",
          role: "button"
        },
          m("i", { "class": "bi bi-chevron-down" }),
          this.getText("LT00000267", "Country Map Data")
        ),
        m('#countryMap-section.align-self-stretch.collapse.show.py-3',
          m('.row',
            m('.col-md-12',
              m('.row.align-items-end.g-2',
                m('.col-md-4.col-sm-10',
                  m('label.form-label', this.getText('LT00000243', 'Managed Country')),
                  m(SingleSelectComponent, {
                    items: Object.values(countriesMap).filter((country) => !userManagedCountries.includes(country.code) && country.code !== user?.defaultCountryCode),
                    selectedItem: selectedCountry,
                    allowEmpty: false,
                    filterable: false,
                    onSelect: (v) => { selectedCountry = v }
                  })
                ),
                m('.col-sm-1',
                  m('.d-grid',
                    m('button.btn.btn-primary', { type: 'button', onclick: addCountry(user, onChange) }, this.getText('LT00000090', 'Add'))
                  )
                )
              )
            )
          ),
          m("hr.my-3"),
          m('.row.g-3',
            user && m('.col-md-12',
              m(CountryMapFormCardView, {
                key: countriesMap[user.defaultCountryCode]?.name,
                userCountryMap: user.countryMap[user.defaultCountryCode],
                isDefaultCountry: true,
                country: countriesMap[user.defaultCountryCode],
                onChange: (countryMapData) => {
                  const userClone = structuredClone(user);
                  userClone.countryMap[user.defaultCountryCode] = countryMapData;
                  onChange(userClone);
                }
              })
            ),
            userManagedCountries.map((countryCode) => m('.col-md-12',
              m(CountryMapFormCardView, {
                key: countriesMap[user.defaultCountryCode]?.name,
                userCountryMap: user.countryMap[countryCode],
                isDefaultCountry: false,
                country: countriesMap[countryCode],
                onChange: (countryMapData) => {
                  const userClone = structuredClone(user);
                  if (countryMapData === null) {
                    delete userClone.countryMap[countryCode];
                  } else {
                    userClone.countryMap[countryCode] = countryMapData;
                  }
                  onChange(userClone);
                }
              })
            ))
          )
        ),
        this.getBaseViews()
      )
    }
  };
}
